import cn from 'classnames';
import styles from './keto-paper.module.css';

export interface KetoPaperProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {}

export default function KetoPaper({
  children,
  className,
  ...props
}: KetoPaperProps) {
  return (
    <div className={cn(className, styles.paper)} {...props}>
      {children}
    </div>
  );
}
